export { default } from './SpotView';
